import Button from "@src/components/Button/Button";
import Input from "@src/components/Input/Input";
import Logo from "@src/components/Logo/Logo";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { useUserStore } from "@src/stores/userStore";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRedirectIfAuthenticated from "@src/hooks/useRedirectIfAuthenticated";
import FormField from "@src/components/FormField/FormField";
import SplitPage from "@src/layout/SplitPage";
import sparkles from "/sparkles.svg";
import loginImage from "/yourpasswordisbadguyuchiha68_002.webp";

import './styles/login.sass'

type FormValues = {
    email: string;
    password: string;
};

const schema = yup.object().shape({
    email: yup
        .string()
        .email("Please check that you typed a correct email")
        .required(),
    password: yup.string().required("Password required"),
});
const Login = () => {
    return <SplitPage leftComponent={<Left />} rightComponent={<Form />} />
}

const altText = "A digital sketch of two characters. One is looking over the other's shoulder with a wide grin, teasingly asking \"Your password is 'badGuyuch1ha68'?\". The other is visibly annoyed and trying to hide his face behind his phone. Or the way around."
const Left = () => {
    return (
        <div className='sidebar'>
            <div className="logo-block">
                <span className="text">Welcome to</span>
                <Logo size="xl" color='white' />
            </div>
            <div className="caption-block">
                <img src={sparkles} alt="another sparkle" className="sparkle2" />
                <span>Your over-engineered character <br />reference sheet</span>
                <img src={sparkles} alt="sparkles!" className="sparkle1" />
            </div>
            <div className="login-image">
                <img src={loginImage} alt={altText} />
            </div>
        </div>
    )
}

const Form = () => {
    const { login, token } = useUserStore();
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>({
        resolver: yupResolver(schema),
    });

    const navigate = useNavigate();
    const onSubmit: SubmitHandler<FormValues> = async (data) => {
        setLoading(true);
        try {
            await login(data);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };
    useEffect(() => {
        useRedirectIfAuthenticated(navigate);
    }, [token]);
    return (
        <div className="wrapper">
            <h2>Login to your account </h2>
            <div className="form-container">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormField errors={errors} name="email">
                        <Input
                            type="text"
                            name="email"
                            placeholder="Your e-mail"
                            register={register}
                            required
                        />
                    </FormField>
                    <FormField name="password" errors={errors}>
                        <Input
                            type="password"
                            name="password"
                            placeholder="Your password"
                            register={register}
                            required
                        />
                    </FormField>
                    <Button
                        preset="secondary"
                        type="submit"
                        isLoading={loading}
                    >
                        Submit
                    </Button>
                </form>
                <Link to="/reset-password" style={{ marginTop: '3rem' }}>Forgot password ?</Link>
            </div>

            <div className="login-image">
                <img src={loginImage} alt={altText} />
            </div>
        </div>
    );
};
export default Login;
